import { useEffect } from 'react';

import {
  sendManagerEvent,
  useManagerCtxSelector,
  useManagerStateMatchesAllOf,
} from '../../../../xstate/app.xstate';

/**
 * False until this org's details load: a stale org's parentId must not decide it.
 * Loads them itself, because only the Details tab did, so a tab opened directly never knew.
 */
export const useIsRootOrg = (orgId: string): boolean => {
  const ready = useManagerStateMatchesAllOf([
    'orgRelated.ready.currentOrg.selected',
  ]);
  const loadedId = useManagerCtxSelector((ctx) => ctx.orgDetails?.id);

  useEffect(() => {
    if (ready && orgId && loadedId !== orgId) {
      sendManagerEvent('manager.loadOrg', { orgId });
    }
  }, [ready, orgId, loadedId]);

  return useManagerCtxSelector(
    (ctx) => ctx.orgDetails?.id === orgId && !ctx.orgDetails.parentId
  );
};
